import { FC } from "react";
import MileageContractListingFilter from "../common/types/mileage-contract-listing-filter";
import MileageContractListingSortKey from "../common/types/mileage-contract-listing-sort-key";
import ListingFilterDefinition from "../../../../../common/components/listing/filter/types/listing-filter-definition";
import ListingSortDefinition from "../../../../../common/components/listing/filter/types/listing-sort-definition";
import ListingFilterComponent from "../../../../../common/components/listing/filter/listing-filter.component";
import mileageContractListingFilterHelper from "./mileage-contract-listing-filters.helper";

type MileageContractListingFilterProps = {
  filters: MileageContractListingFilter[];
  onFiltersChange: (filters: MileageContractListingFilter[]) => void;
  sortKey: MileageContractListingSortKey;
  onSortKeyChange: (sortKey: MileageContractListingSortKey) => void;
};

const MileageContractListingFilterComponent: FC<
  MileageContractListingFilterProps
> = (props) => {
  const filterDefinition: ListingFilterDefinition<MileageContractListingFilter> =
    mileageContractListingFilterHelper().getFilterDefinition();

  const sortDefinition: ListingSortDefinition =
    mileageContractListingFilterHelper().getSortDefinition();

  return (
    <ListingFilterComponent
      appliedFilters={props.filters}
      filterDefinition={filterDefinition}
      onFiltersChange={(appliedFilters) => {
        props.onFiltersChange(appliedFilters as MileageContractListingFilter[]);
      }}
      appliedSortKey={props.sortKey}
      onSortKeyChange={(value) =>
        props.onSortKeyChange(value as MileageContractListingSortKey)
      }
      sortDefinition={sortDefinition}
    />
  );
};

export default MileageContractListingFilterComponent;
